import React from "react";
import { useNavigate } from "react-router-dom";
import { LosLogo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { ChangePasswordCard } from "@/components/settings/ChangePasswordCard";

/** Shown instead of the workspace when the server requires a password change before anything else. */
export default function ChangePasswordPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col bg-background px-6 py-8 sm:px-12" data-testid="change-password-page">
      <LosLogo className="text-[18px]" />
      <div className="flex flex-1 items-center justify-center">
        <div className="w-full max-w-[520px]">
          <h1 className="font-display text-[28px] font-extrabold tracking-[-0.03em] text-[hsl(var(--navy))]">Bytt passord</h1>
          <p className="mt-2 text-[14px] leading-relaxed text-muted-foreground">Hei {user?.name?.split(" ")[0]}. {user?.created_by || user?.password_reset_at ? "Du har fått et midlertidig passord. Skriv det inn, og velg ditt eget før du går videre" : "Kontoen krever nytt passord før arbeidsflaten kan brukes"} – ingen andre ser det du velger.</p>
          <div className="mt-6 rounded-[18px] border border-black/[0.06] bg-white p-5 shadow-float">
            <ChangePasswordCard compact onDone={() => navigate("/", { replace: true })} />
          </div>
          <button type="button" onClick={logout} className="mt-4 text-[12.5px] text-muted-foreground hover:text-foreground" data-testid="change-password-logout">Logg ut</button>
        </div>
      </div>
    </div>
  );
}
